import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './Media.scss';
import {
	CATALOG_URL_MATCH,
	CATALOG_URL_REPLACE,
	CATALOG_SPACE_MATCH,
	CATALOG_SPACE_REPLACE,
} from 'utils/constants'

const Media = ({
	className,
	customization,
	href,
	gradientColor,
	bgColor,
	img,
	children,
	onClick,
	callToAction,
	target,
	id,
	alt,
	title
}) => {

	const CustomTag = href ? 'a' : 'div';
	const patternTest = (variable, regex = /^\#([\da-fA-F]{6})$/ ) => regex.test(variable)

	const renderGradient = () => {
		if (patternTest(gradientColor)) {
			return (
				<div
					className="Media__photo-gradient"
					style={`background: linear-gradient ${gradientColor}00 0%, ${gradientColor}FF 40px`}
				/>
			)
		}
		return false
	}

	const renderButton = () => {
		return (
			<div className="Media__cta">
				Saiba Mais
			</div>
		)
	}

	const getCatalogBackgroundImageUrl = (bgImage) => {
		return `${bgImage
			.replace(CATALOG_URL_MATCH, CATALOG_URL_REPLACE)
			.replace(CATALOG_SPACE_MATCH, CATALOG_SPACE_REPLACE)}?s=fill&h=320&w=1920&q=90`
	}

	const style = {
		backgroundImage: `url(${getCatalogBackgroundImageUrl(img)})`,
	}

	if (patternTest(gradientColor)) {
		style.backgroundColor = gradientColor
	}

	if (patternTest(bgColor)) {
		style.backgroundColor = bgColor
	}

	const getCustomTagStyling = (tagType = 'div') => {

		let Tag = tagType
		const classCategory = 'Media--category'

		if(className === classCategory){
			Tag = 'h1'
		}

		let customProp
		if(!customization && Tag === 'a'){
			customProp = {
				href,
				target,
			}
		}

		return (
		<Tag
			className={`Media ${className}` }
			style={style}
			onClick={onClick}
			id={id}
			alt={alt}
			title={title}
			{...customProp}
		>
			{renderGradient()}
			{callToAction && renderButton()}
			{children}
		</Tag>)
	}

	return (
		<Fragment>
			{customization &&
			( href ?
				<a rel="noreferrer" href={href} target='_blank'>
					{getCustomTagStyling()}
				</a>
				:
				getCustomTagStyling()
			)}
			{!customization && getCustomTagStyling(CustomTag)}
		</Fragment>
	)

}

Media.defaultProps = {
	href: null,
	callToAction: null,
	customization: null,
	gradientColor: null,
	bgColor: null,
	img: '',
	className: '',
	children: null,
	onClick: null,
	target: null,
	id: null,
	alt: null,
	title: null,
	customBgSize: null,
}

Media.propTypes = {
	href: PropTypes.string,
	callToAction: PropTypes.bool,
	customization: PropTypes.bool,
	gradientColor: PropTypes.string,
	bgColor: PropTypes.bool,
	img: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node,
	onClick: PropTypes.func,
	target: PropTypes.string,
	id: PropTypes.string,
	alt: PropTypes.string,
	title: PropTypes.string
}

export default Media;
